import { useEffect } from "react";
import {
  IUBENDA_SCRIPT_ID,
  IUBENDA_SCRIPT_SRC,
} from "@/constants/iubenda";

export function IubendaScript() {
  useEffect(() => {
    if (document.getElementById(IUBENDA_SCRIPT_ID)) {
      return;
    }

    const script = document.createElement("script");
    script.id = IUBENDA_SCRIPT_ID;
    script.src = IUBENDA_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return null;
}
